<div title="Ajouter aux favoris" class="favorite-icon pointer" *ngIf="isVisible">
  <app-icon  
    [type]="isSelected ? 'favorite' : 'favorite-outline'" 
    (click)="updateFavorite()">
  </app-icon>
</div>
